export default __webpack_public_path__ + "static/media/Spin.55ed7e0e.svg";